import { motion } from 'framer-motion';
import SidebarGalleryPage from '../Main/Sidebargallery';
import Myimage from "../../assets/Career&Guidence/tnp_banner.jpg"


const placementPoliciesInfo = {
  intro: "Students attending the Campus process may note the following Placement regulations:-",
  policies: [
    "Once the placement process is initiated, students may attend the presentations made by the company and make their decision to attend the selection process. Once they have opted for attending the process of the company, they will not be permitted to drop out at any stage of the process.",
    "Students are required to keep their Identity cards with them at the time of appearing in the selection process and shall produce the same if asked by either the selection team member or the placement cell team.",
    "Any student who has been selected by the company through a close campus will not be permitted for attending the next close campus unless the difference in the offered packages is Rs. one lakh or more. Once 85% of the students of a particular branch are placed, a second opportunity may be provided.",
    "If a student opts for a second job and gets selected, they must submit a letter of regret (for the first organization) to the T&P cell immediately upon receiving the second offer.",
    "Students are advised not to contact the selection team members directly at any level of placement without permission from the T&P cell.",
    "The Placement office is responsible for centrally receiving offer letters, distributing, and dispatching acceptance letters to the companies.",
    "Offer letters should be sent to the Placement office for distribution to students."
  ],
  dreamJob: "The student may appear for a Dream Job even if she already has an offer from another company.",
  note: "Note: All the above policies are liable to be changed at any time solely at the discretion of the T&P Cell authorities for the welfare of the students.",
  reminders: [
    "Report at the placement center 30 minutes before the interview starts.",
    "Keep an updated copy of your resume.",
    "Have a sufficient number of documents, certificates, and photographs ready and organized.",
    "Unless specifically asked to report later, students waiting for their turn should wait patiently at the placement venue. Missing an interview is the candidate's responsibility.",
    "Dress neatly in ironed formal attire and polished formal shoes. Nails should be clipped.",
    "If a candidate decides not to appear for the test/interview, they should inform the placement center as soon as possible."
  ],
  documentsChecklist: [
    "College Identity Proof",
    "Alternate Identity Proof (Driving License, PAN card, Voter Id, Aadhar Card, Passport)",
    "Resume",
    "Caste Certificate",
    "Passport-size Photographs (Minimum two)",
    "Mark sheets of 10th, 12th, and all Semesters",
    "Certificates of Achievements",
    "Internship/Training Certificates",
    "Minor Project and Major Project reports"
  ]
};


export default function PlacementPoliciesSection() {
  return (
    <div className="min-h-screen bg-gray-100 p-12">
      <div className="flex flex-col lg:flex-row gap-10">

        {/* Main Content */}
        <motion.div 
          className="lg:col-span-2"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
          <img 
            src={Myimage}
            alt="Career Guidance & Placement Cell Banner" 
            className="w-full rounded-lg border-4 border-teal-500 p-2 mb-10"
          />

          {/* <hr className="mt-7 mb-2 border-t border-dotted border-gray-400" /> */}

         <div className="border-4 border-teal-500 p-2 rounded-lg">
              <h2 className="text-2xl font-bold mb-4 text-white bg-[#00BFA5] p-2 rounded-sm">
                  Placement Policies
                </h2>
                <p className="mb-4 p-2">{placementPoliciesInfo.intro}</p>
                <ul className="list-decimal list-inside pl-4 ">
                  {placementPoliciesInfo.policies.map((policy, index) => (
                    <li key={index} className="mb-4">{policy}</li>
                  ))}
                </ul>

                <h3 className="text-lg font-bold p-2">Dream Job</h3>
                <p className="p-2">{placementPoliciesInfo.dreamJob}</p>

                <p className="text-sm font-semibold text-red-500 italic p-2">{placementPoliciesInfo.note}</p>

                <h3 className="text-lg font-bold p-2">Reminders</h3>
                <ul className="list-disc list-inside pl-4">
                  {placementPoliciesInfo.reminders.map((reminder, index) => (
                    <li key={index} className="mb-1">{reminder}</li>
                  ))}
                </ul>

                <h3 className="text-lg font-bold p-2">Documents Checklist</h3>
                <ul className="list-disc list-inside pl-4">
                  {placementPoliciesInfo.documentsChecklist.map((document, index) => (
                    <li key={index} className="mb-1">{document}</li>
                  ))}
                </ul>
         </div>

          {/* <hr className='mt-6 mb-3'/> */}
          <div className='border-4 border-[#00BFA5] mt-10 rounded-lg p-2'>
          <div>
            <h1 className='font-bold bg-[#00BFA5] text-white p-2 text-xl'>Contact Us</h1>
            <div className='p-4'>
            <p>Mr. Pramod Sharma</p>
            <p>Training and Placement Officer</p>
            <p>Mobile: 9425511223</p>
            <p>Email: <a href="pramod511223@gmail.com" className='text-blue-600 underline'>pramod511223@gmail.com</a></p>
            </div>
          </div>
          </div>
        </motion.div>

        {/* Sidebar - Gallery */}
        <SidebarGalleryPage></SidebarGalleryPage>
      </div>
    </div>
  )
}
